<div class="p-6 flex flex-col gap-5">
  <div class="flex justify-between align-items-center">
    <h2 class="text-2xl font-bold text-sigecom-dark-gray">
      {{
        isEditing
          ? "Editar Parametrização da fase"
          : "Cadastrar Parametrização da fase"
      }}
    </h2>
    <sigecom-button
      class="text-[#012169]"
      routerLink="/parametrizacao-etapa"
      icon="list"
      title="FASES "
    ></sigecom-button>
  </div>

  <form
    [formGroup]="stepParameterizationForm"
    (keydown.enter)="onEnter($event)"
  >
    <div class="shadow-lg p-4 px-5 bg-white rounded-lg">
      <div class="my-2">
        <sigecom-stepper
          [currentStep]="currentStep"
          (currentStepChange)="onStepChange($event)"
        >
          <sigecom-step icon="gear">
            <div class="grid grid-cols-6 gap-2">
              <div class="col-span-full mb-3">
                <h3 class="font-semibold text-lg">Dados básicos</h3>
              </div>
              <div class="col-span-2">
                <sigecom-new-dropdown
                  label="Ano"
                  [options]="yearsArray"
                  [optionLabel]="'key'"
                  [optionIdentify]="'value'"
                  (changeOption)="onYearChange($event)"
                  placeholder="Selecione o ano"
                />
              </div>
              <div class="col-span-2">
                <sigecom-new-dropdown
                  [required]="true"
                  label="Evento"
                  [options]="events!.content!"
                  [optionLabel]="'eveTxNome'"
                  [optionIdentify]="'eveNrId'"
                  formControlName="eveNrId"
                  (changeOption)="onEventChange($event)"
                  placeholder="Selecione o evento"
                  searchble
                  paged
                  [totalPages]="events.totalPages || 1"
                  [currentPage]="events.number || 0"
                  (searchChange)="onEventSearch($event)"
                  (pageChange)="onEventPageChange($event)"
                />
              </div>

              <div class="col-span-2">
                <sigecom-new-dropdown
                  [required]="true"
                  label="Bloco de competição da modalidade"
                  [options]="competitionsBlocks!.content!"
                  [optionLabel]="'bloTxNome'"
                  [optionIdentify]="'bloNrId'"
                  formControlName="bloNrId"
                  placeholder="Selecione o bloco"
                  (changeOption)="onBlockChange($event)"
                />
              </div>

              <div class="col-span-2">
                <sigecom-new-dropdown
                  [required]="true"
                  label="Competição da modalidade"
                  [options]="competitions!.content!"
                  [optionLabel]="'comTxNome'"
                  [optionIdentify]="'comNrId'"
                  formControlName="comNrId"
                  placeholder="Selecione a competição"
                  (changeOption)="onCompetitionChange($event)"
                  searchble
                  paged
                  [totalPages]="competitions.totalPages || 1"
                  [currentPage]="competitions.number || 0"
                  (searchChange)="onCompetitionSearch($event)"
                  (pageChange)="onCompetitionPageChange($event)"
                />
              </div>

              <div class="col-span-2">
                <sigecom-new-dropdown
                  [required]="true"
                  label="Categoria"
                  [options]="categories.content!"
                  [optionLabel]="'catTxNomeComNaipe'"
                  [optionIdentify]="'catNrId'"
                  formControlName="catNrId"
                  placeholder="Selecione a categoria"
                  (changeOption)="onCategoryChange($event)"
                  searchble
                  paged
                  [totalPages]="categories.totalPages || 1"
                  [currentPage]="categories.number || 0"
                  (searchChange)="onCategorySearch($event)"
                  (pageChange)="onCategoryPageChange($event)"
                />
              </div>

              <div class="col-span-2" *ngIf="espNrId">
                <sigecom-new-dropdown
                  [required]="false"
                  label="Modelo"
                  [options]="competitionModels.content!"
                  [optionLabel]="'mocTxNome'"
                  [optionIdentify]="'mocNrId'"
                  formControlName="mocNrId"
                  placeholder="Selecione o modelo"
                  (changeOption)="onCompetitionModelChange($event)"
                />
              </div>

              <div class="col-span-6">
                <sigecom-multiselect
                  [isRequired]="true"
                  label="Federações participantes"
                  [options]="federations.content ?? []"
                  identifyProperty="fedNrId"
                  displayProperty="fedTxNome"
                  [selectedOptionsIds]="selectedFederationIds"
                  (selectedOptionsIdsChange)="onFederationsChange($event)"
                  [errorMessage]="showError('federacoesEtapaIds')"
                />
              </div>

              <sigecom-input-container
                class="col-span-full"
                label="Nome da fase"
                [errorMessage]="showError('petTxNome')"
              >
                <input
                  sigecom-input
                  type="text"
                  placeholder="Digite o nome da etapa, ex: Fase Regional 1"
                  name="petTxNome"
                  formControlName="petTxNome"
                />
              </sigecom-input-container>

              <sigecom-input-container
                class="col-span-full"
                label="Descrição da fase"
              >
                <textarea
                  sigecom-input
                  placeholder="Descreva o objetivo ou detalhes da fase"
                  name="petTxDescricao"
                  formControlName="petTxDescricao"
                ></textarea>
              </sigecom-input-container>

              <div class="col-span-full flex flex-col gap-2">
                <p class="font-semibold text-sigecom-dark-gray">
                  Banner da fase
                </p>
                <div
                  class="w-full min-h-[160px] rounded-lg border border-sigecom-gray/40 bg-sigecom-light-gray/30 overflow-hidden flex items-center justify-center"
                >
                  <img
                    *ngIf="bannerPreview; else emptyBanner"
                    [src]="bannerPreview"
                    alt="Banner da fase"
                    class="w-full h-[180px] object-cover"
                  />
                  <ng-template #emptyBanner>
                    <div
                      class="flex flex-col items-center gap-2 text-sigecom-gray py-8"
                    >
                      <fa-icon [icon]="'image'" class="text-3xl"></fa-icon>
                      <span class="text-sm">Nenhum banner selecionado</span>
                    </div>
                  </ng-template>
                </div>
                <sigecom-file-upload
                  label="Selecionar banner"
                  accepts="image/png, image/jpeg"
                  [acceptedTypes]="bannerAcceptedTypes"
                  [lastBase64]="bannerPreview"
                  (base64)="onBannerBase64Change($event)"
                  (format)="onBannerFormatChange($event)"
                />
              </div>

              <div class="col-span-2">
                <sigecom-new-dropdown
                  label="Formato da fase"
                  [options]="stepTypes"
                  [optionLabel]="'label'"
                  [optionIdentify]="'value'"
                  formControlName="petTxTipo"
                  placeholder="Selecione o formato da fase"
                  ngClass="rounded-xl"
                />
              </div>

              <div class="col-span-2">
                <sigecom-input-container label="Permitir alterações">
                  <div class="p-1.5">
                    <sigecom-switch
                      [switchState]="!isBlocked"
                      (switchStateChange)="onSwitchStateChange($event)"
                    />
                  </div>
                </sigecom-input-container>
              </div>

              <div class="col-span-2">
                <sigecom-input-container
                  label="Permitir repetição de estado na chave"
                >
                  <div class="p-1.5">
                    <sigecom-switch
                      [switchState]="permiteMesmoEstado"
                      (switchStateChange)="
                        onSwitchPermiteMesmoEstadoChange($event)
                      "
                    />
                  </div>
                </sigecom-input-container>
              </div>

              <div class="col-span-full mt-3 mb-3">
                <p class="text-xl font-semibold text-sigecom-dark-gray">
                  Parametrização de Chaves
                </p>
              </div>

              <div class="col-span-full grid grid-cols-2 gap-3">
                <sigecom-input-container
                  label="N° de chaves"
                  class="col-span-1"
                  [errorMessage]="showError('petNrQtdChe')"
                >
                  <input
                    sigecom-input
                    type="number"
                    formControlName="petNrQtdChe"
                    placeholder="Informe a quantidade de chaves (ex: 4)"
                  />
                </sigecom-input-container>

                <sigecom-input-container
                  label="N° de inscrições participantes"
                  class="col-span-1"
                >
                  <input
                    sigecom-input
                    type="number"
                    name="petNrQtdInc"
                    formControlName="petNrQtdInc"
                    placeholder="Ex: 28"
                  />
                </sigecom-input-container>

                <sigecom-input-container
                  label="N° de cabeças de chave de cada grupo"
                  class="col-span-1"
                >
                  <input
                    sigecom-input
                    type="number"
                    name="petNrQuantidadeCabecasDeChave"
                    formControlName="petNrQuantidadeCabecasDeChave"
                    placeholder="Ex: 6"
                  />
                </sigecom-input-container>

                <sigecom-input-container
                  label="Quantidade mínima de passagens"
                  class="col-span-1"
                >
                  <input
                    sigecom-input
                    type="number"
                    name="petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias"
                    formControlName="petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias"
                    placeholder="Ex: 1"
                  />
                </sigecom-input-container>
              </div>
            </div>
          </sigecom-step>

          <sigecom-step icon="volleyball">
            <div class="grid grid-cols-6 gap-2">
              <div class="col-span-full mb-3">
                <h3 class="font-semibold text-lg">Configuração dos embates</h3>
              </div>
              <sigecom-input-container
                class="col-span-2"
                label="N° máximo de jogos do dia"
              >
                <input
                  sigecom-input
                  type="number"
                  placeholder="Digite o número máximo de jogos por dia (ex: 10)"
                  name="petNrMaxJogosDia"
                  formControlName="petNrMaxJogosDia"
                />
              </sigecom-input-container>
              <sigecom-input-container
                class="col-span-2"
                label="Tempo de intervalo dos jogos"
                formControlName="petNrIntervaloJogos"
              >
                <input
                  sigecom-input
                  type="number"
                  placeholder="Ex: 30"
                  name="petNrIntervaloJogos"
                  formControlName="petNrIntervaloJogos"
                />
              </sigecom-input-container>
              <sigecom-input-container
                class="col-span-2"
                label="N° máximo de embates simultâneos"
                formControlName="petNrMaxEmbSimultaneos"
              >
                <input
                  sigecom-input
                  type="number"
                  placeholder="Quantos embates simultâneos? (ex: 3)"
                  name="petNrMaxEmbSimultaneos"
                  formControlName="petNrMaxEmbSimultaneos"
                />
              </sigecom-input-container>

              <sigecom-input-container
                class="col-span-3"
                label="Tempo de duração do embate"
              >
                <input
                  sigecom-input
                  type="number"
                  placeholder="ex: 5"
                  name="petNrDuracaoEmb"
                  formControlName="petNrDuracaoEmb"
                />
              </sigecom-input-container>

              <div class="col-span-3">
                <sigecom-input-container class="h-full" label="Embate direto">
                  <select
                    (change)="onChangeEmbateDireto($event)"
                    formControlName="petBlEmbDireto"
                    class="w-full"
                    name="petBlEmbDireto"
                  >
                    <option value="true">Sim</option>
                    <option value="false">Não</option>
                  </select>
                </sigecom-input-container>
              </div>
              <sigecom-sport-parameterization
                class="col-span-full"
                [petBlEdicaoBloqueada]="!isBlocked"
                [ettNrIdSportTemplateSaved]="ettNrIdSportTemplateSaved"
                [espNrIdPat]="espNrId"
                (ettNrId)="submitSportParameterization($event)"
                [isEditingParametrization]="isEditing"
                [parameterization]="true"
              >
              </sigecom-sport-parameterization>
            </div>
          </sigecom-step>

          <sigecom-step *ngIf="petNrQtdInc.valid" icon="users">
            <div class="col-span-full -mt-3 mb-3">
              <h3 class="font-semibold text-lg">Definição de participantes</h3>
            </div>
            <form [formGroup]="isOtherStepForm">
              <div class="grid grid-cols-5 items-end">
                <sigecom-input-container
                  [showBorder]="false"
                  label="De outra fase?"
                  [isRequired]="true"
                >
                  <div class="flex gap-2">
                    <label class="flex items-center gap-3">
                      <input
                        type="radio"
                        name="isOutherStep"
                        value="sim"
                        class="w-4 h-4 appearance-none rounded-full border-[5px] bg-gray-300 border-gray-300 checked:bg-gray-200 checked:border-[#012169] focus:ring-0"
                        formControlName="isOutherStep"
                      />
                      <span class="text-sigecom-dark-gray text-sm pl-1"
                        >Sim</span
                      >
                    </label>
                    <label class="flex items-center gap-3">
                      <input
                        type="radio"
                        name="isOutherStep"
                        value="nao"
                        class="w-4 h-4 appearance-none rounded-full border-[5px] bg-gray-300 border-gray-300 checked:bg-gray-200 checked:border-[#012169] focus:ring-0"
                        formControlName="isOutherStep"
                      />
                      <span class="text-sigecom-dark-gray text-sm pl-1"
                        >Não</span
                      >
                    </label>
                  </div>
                </sigecom-input-container>

                <div
                  *ngIf="isOtherStepValue"
                  class="duration-300 animate-fade-in col-span-2 pr-2 z-10"
                >
                  <sigecom-new-dropdown
                    label="Fase"
                    formControlName="fase"
                    [options]="faseOptions?.content ?? []"
                    optionIdentify="petNrId"
                    optionLabel="petTxNome"
                    placeholder="Selecione a fase"
                    (changeOption)="onFaseChange($event)"
                  />
                </div>
                <div
                  *ngIf="isOtherStepValue"
                  class="col-span-2 duration-300 animate-fade-in z-10"
                >
                  <sigecom-new-dropdown
                    label="Chave"
                    formControlName="chave"
                    [options]="clashOptions?.content ?? []"
                    optionIdentify="cheNrId"
                    optionLabel="cheTxNome"
                    placeholder="Selecione a chave"
                    (changeOption)="onChaveChange($event)"
                  />
                </div>
              </div>
            </form>

            <div class="pt-4 flex justify-center gap-2">
              <app-item-selector
                class="w-3/4"
                label="Selecione as incrições:"
                [items]="
                  isOtherStepValue === undefined
                    ? []
                    : isOtherStepValue
                      ? participantsOtherPhase
                      : participants
                "
                [placeholder]="'Buscar inscrição'"
                [statusItemFn]="statusItemFn"
                [statusItemClassFn]="statusItemClassFn"
                iconItemName="key"
                [iconItemDisableFn]="iconItemDisableFn"
                iconItemColor="[#E9CA26]"
                classIconItem=" w-7 h-7 bg-sigecom-info rounded-full flex justify-center items-center"
                (search)="filterByName($event)"
                (add)="addParticipants($event)"
              >
                <sigecom-button
                  *ngIf="!isOtherStepValue"
                  (buttonClicked)="addAllParticipants()"
                  title="Classificar todos"
                  type="info"
                />
                <div
                  below-search-bar
                  *ngIf="
                    (isOtherStepValue ? participantsOtherPhase : participants)
                      .length === 0
                  "
                  class="text-sm text-sigecom-gray text-center"
                >
                  A lista está vazia!
                </div>
                <div class="flex justify-between">
                  <sigecom-button
                    *ngIf="isOtherStepValue"
                    (buttonClicked)="addAllParticipants()"
                    title="Selecionar todos"
                    type="info"
                    class="rounded-md bg-[#012169]"
                  />
                </div>
              </app-item-selector>

              <sigecom-item-selected-list
                emptyListMessage="Nenhum inscrito selecionado"
                hasHeadButton
                (headButtonFn)="removeAllParticipants()"
                class="w-full"
                [selectedItems]="
                  isOtherStepValue === undefined ? [] : selectedEntries
                "
                [label]="'Inscrições selecionadas: '"
                [qtdMaxItems]="qtdMaxParticipantsStepParametrization"
                (remove)="removeParticipant($event)"
                iconItemName="key"
                [iconItemDisableFn]="iconItemDisableFn"
                iconItemColor="[#E9CA26]"
                classIconItem="w-7 h-7 bg-sigecom-info rounded-full flex justify-center items-center"
              />
            </div>
          </sigecom-step>

          <sigecom-step icon="list" *ngIf="isEditing">
            <app-key-generation
              [petNrId]="petNrId"
              [petBlockEdit]="isBlocked"
              [amountOfKeysGenerated]="qtdChaves"
              (keyInfoOutput)="keysFormChange($event)"
            />
          </sigecom-step>

          <sigecom-step icon="calendar-day">
            <div class="flex flex-col gap-4">
              <!-- Header -->
              <div class="flex w-full items-center justify-between">
                <p class="text-lg font-semibold text-sigecom-gray">
                  Configurar rodadas da competição
                </p>
                <form [formGroup]="rodadaOrigemForm" class="flex gap-4">
                  <label
                    class="flex items-center gap-2 text-sm text-sigecom-gray"
                  >
                    <input type="radio" formControlName="modo" value="criar" />
                    Criar novas rodadas
                  </label>
                  <label
                    class="flex items-center gap-2 text-sm text-sigecom-gray"
                  >
                    <input
                      type="radio"
                      formControlName="modo"
                      value="existente"
                    />
                    Utilizar rodadas existentes
                  </label>
                </form>
              </div>

              <sigecom-button
                *ngIf="!isModoRodadaExistente"
                (buttonClicked)="adicionarRodada()"
                [title]="'ADICIONAR NOVA RODADA'"
                class="text-sigecom-info self-end"
                icon="plus"
              />

              <div
                *ngIf="isModoRodadaExistente"
                class="rounded-lg border p-3 flex flex-col gap-3 border-sigecom-gray"
              >
                <sigecom-new-dropdown
                  label="Parametrização de origem"
                  [options]="parametrizacoesCompartilhaveis.content ?? []"
                  optionLabel="petTxNome"
                  optionIdentify="petNrId"
                  placeholder="Selecione a parametrização"
                  (changeOption)="onParametrizacaoOrigemChange($event)"
                />

                <ng-container *ngIf="petNrIdOrigemSelecionado">
                  <p
                    class="text-sm text-sigecom-gray"
                    *ngIf="!rodadasDaParametrizacaoOrigem.length"
                  >
                    Nenhuma rodada disponível para reaproveitar.
                  </p>

                  <div
                    class="flex items-center gap-2"
                    *ngFor="let rodada of rodadasDaParametrizacaoOrigem"
                  >
                    <input
                      type="checkbox"
                      [checked]="
                        isRodadaSelecionadaParaVincular(rodada.rodNrId)
                      "
                      (change)="toggleRodadaParaVincular(rodada.rodNrId)"
                    />
                    <span class="text-sm text-sigecom-dark-gray">
                      {{ rodada.rodTxNome }} ({{ rodada.rodDtInicio }} -
                      {{ rodada.rodDtFim }})
                    </span>
                  </div>

                  <sigecom-button
                    *ngIf="rodadasDaParametrizacaoOrigem.length"
                    (buttonClicked)="vincularRodadasSelecionadas()"
                    title="ADICIONAR RODADAS SELECIONADAS"
                    class="text-sigecom-info self-start"
                    icon="link"
                  />
                </ng-container>
              </div>
              <!-- Table -->
              <div
                class="rounded-lg border flex-col flex gap-2 p-2 border-sigecom-gray"
                formArrayName="rodadaForms"
              >
                <!-- Table Header -->
                <div class="grid grid-cols-11 font-semibold text-sigecom-gray">
                  <div class="col-span-1"></div>
                  <div class="col-span-1 text-center">Ordem</div>
                  <div class="col-span-2 pl-2">Nome da rodada</div>
                  <div class="col-span-2 pl-2">Tipo da rodada</div>
                  <div class="col-span-2 pl-2">Data início</div>
                  <div class="col-span-2 pl-2">Data fim</div>
                  <div class="col-span-1 text-center">Ação</div>
                </div>

                <!-- Table Content -->

                <ng-container *ngIf="rodadaForms.controls.length < 1">
                  <p class="text-sigecom-danger text-center my-2">
                    É necessário ao menos uma rodada
                  </p>
                </ng-container>

                <div
                  class="grid grid-cols-11 items-center justify-center gap-2"
                  *ngFor="
                    let rodada of rodadaForms.controls;
                    let i = index;
                    let l = last
                  "
                  [formGroupName]="i"
                >
                  <div
                    class="col-span-1 flex flex-col items-center text-sigecom-gray text-sm justify-center leading-none gap-1"
                  >
                    <button
                      type="button"
                      [ngClass]="{
                        'text-sigecom-gray/30 cursor-default': i == 0,
                        'hover:text-sigecom-info': i != 0,
                      }"
                      title="Subir posição"
                      (click)="changePosition(i, 'up')"
                    >
                      <fa-icon icon="chevron-up" />
                    </button>
                    <button
                      type="button"
                      [ngClass]="{
                        'text-sigecom-gray/30 cursor-default': l,
                        'hover:text-sigecom-info': !l,
                      }"
                      title="Descer posição"
                      (click)="changePosition(i, 'down')"
                    >
                      <fa-icon icon="chevron-down" />
                    </button>
                  </div>
                  <div
                    class="col-span-1 text-center font-semibold text-sigecom-gray"
                  >
                    {{ i + 1 }}
                  </div>
                  <sigecom-input-container
                    class="col-span-2"
                    smallInput
                    [errorMessage]="
                      showError('rodadaForms.' + i + '.rodTxNome')
                    "
                  >
                    <input
                      sigecom-input
                      class="w-full"
                      type="text"
                      formControlName="rodTxNome"
                      placeholder="Digite"
                    />
                  </sigecom-input-container>
                  <sigecom-new-dropdown
                    class="col-span-2"
                    formControlName="rodTxTipoRodada"
                    [options]="rodadaTypes"
                    [optionLabel]="'label'"
                    [optionIdentify]="'value'"
                    placeholder="Selecione"
                    smallInput
                    [error]="showError('rodadaForms.' + i + '.rodTxTipoRodada')"
                  />
                  <sigecom-input-container
                    class="col-span-2"
                    smallInput
                    [errorMessage]="
                      showError('rodadaForms.' + i + '.rodDtInicio')
                    "
                  >
                    <input
                      sigecom-input
                      class="w-full"
                      type="date"
                      formControlName="rodDtInicio"
                      placeholder="Selecione"
                    />
                  </sigecom-input-container>
                  <sigecom-input-container
                    class="col-span-2"
                    smallInput
                    [errorMessage]="showError('rodadaForms.' + i + '.rodDtFim')"
                  >
                    <input
                      sigecom-input
                      class="w-full"
                      type="date"
                      formControlName="rodDtFim"
                      placeholder="Selecione"
                    />
                  </sigecom-input-container>
                  <div class="col-span-1 text-center">
                    <button
                      type="button"
                      class="text-sigecom-danger"
                      title="Remover rodada"
                      (click)="removerRodada(i)"
                    >
                      <fa-icon icon="trash" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </sigecom-step>
        </sigecom-stepper>

        <sigecom-action-buttons
          (cancelClick)="cancelForm()"
          [isSaveDisabled]="
            !!stepParameterizationForm.invalid ||
            isOtherStepForm.invalid ||
            isBlocked
          "
          (saveClick)="onSubmitStepForms()"
        >
        </sigecom-action-buttons>
      </div>
    </div>
  </form>
</div>
